module.exports = urlToImage;

function urlToImage (url, fn) {
  var img = new Image();
  if (fn) img.onload = fn.bind(null, img);
  img.src = url;
  return img;
}



//////////////////
// WEBPACK FOOTER
// ./~/fix-orientation/lib/url-to-image.js
// module id = 340
// module chunks = 0